"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityType = void 0;
// eslint-disable-next-line no-shadow
var ActivityType;
(function (ActivityType) {
    ActivityType["UNKNOWN"] = "unknown";
    ActivityType["RAISED"] = "raised";
    ActivityType["ASSIGNED"] = "assigned";
    ActivityType["EDITED"] = "edited";
    ActivityType["ADD_COMMENT"] = "addedComment";
    ActivityType["DELETE_COMMENT"] = "deleteComment";
    ActivityType["EDIT_COMMENT"] = "editComment";
})(ActivityType = exports.ActivityType || (exports.ActivityType = {}));
exports.default = ActivityType;
